module.exports = __webpack_public_path__ + "static/feature-4-1d0d98c3c186cae1e4e75a35991cac3a.svg";